import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-10" }
const _hoisted_2 = { class: "col-md-12 fv-row" }
const _hoisted_3 = { class: "row fv-row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_6 = { class: "required" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a card holder's name"
}, null, -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "row mb-10" }
const _hoisted_11 = { class: "col-md-12 fv-row" }
const _hoisted_12 = { class: "row fv-row" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_15 = { class: "required" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a card holder's name"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-10" }
const _hoisted_21 = { class: "col-md-12 fv-row" }
const _hoisted_22 = { class: "row fv-row" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "required fs-6 fw-bold form-label mb-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "required fs-6 fw-bold form-label mb-2" }
const _hoisted_30 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-10" }
const _hoisted_34 = { class: "col-md-12 fv-row" }
const _hoisted_35 = { class: "row fv-row" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_38 = { class: "required" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a card holder's name"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "d-flex flex-column mb-10" }
const _hoisted_44 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  class: "form-check text-left",
  style: {"text-align":"left !important"}
}
const _hoisted_47 = /*#__PURE__*/_createVNode("input", {
  class: "form-check-input text-left",
  type: "checkbox",
  value: "",
  id: "flexCheckChecked",
  checked: ""
}, null, -1)
const _hoisted_48 = {
  class: "form-check-label",
  for: "flexCheckChecked"
}
const _hoisted_49 = { class: "text-center mt-15" }
const _hoisted_50 = { class: "indicator-label" }
const _hoisted_51 = {
  key: 1,
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_card_submit",
  class: "btn btn-primary"
}
const _hoisted_52 = { class: "indicator-label" }
const _hoisted_53 = { class: "indicator-progress" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock(_component_Form, {
    id: "kt_organization_form",
    class: "form fv-plugins-bootstrap5 fv-plugins-framework",
    novalidate: "novalidate",
    onSubmit: _ctx.save,
    "validation-schema": _ctx.submitOrganization
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.translate("organization")), 1),
                _hoisted_7
              ]),
              _createVNode(_component_Field, {
                disabled: !_ctx.isEditionEnabled,
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                autofocus: "",
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                name: "nameOnCard",
                id: "organization-name"
              }, null, 8, ["disabled", "modelValue"]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_ErrorMessage, { name: "nameOnCard" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.translate("industry")), 1),
                _hoisted_16
              ]),
              _createVNode(_component_Field, {
                disabled: !_ctx.isEditionEnabled,
                modelValue: _ctx.form.industry,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.industry = $event)),
                id: "industry_selector",
                name: "industry",
                class: "form-select form-select-solid",
                "data-control": "select2",
                "data-hide-search": "true",
                "data-placeholder": "Month",
                as: "select"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.industries, (industry, industryIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      key: industryIndex,
                      value: industry.key
                    }, _toDisplayString(_ctx.translate(`industria.${industry.key}`)), 9, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_ErrorMessage, { name: "industry" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("employees")), 1),
              _createVNode(_component_Field, {
                disabled: !_ctx.isEditionEnabled,
                modelValue: _ctx.form.employees,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.employees = $event)),
                name: "employees",
                class: "form-select form-select-solid",
                "data-control": "select2",
                "data-hide-search": "true",
                "data-placeholder": "Year",
                as: "select",
                id: "empleados"
              }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quantityOptions, (option, optionIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      key: optionIndex,
                      value: option.value
                    }, _toDisplayString(option.show), 9, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_ErrorMessage, { name: "employees" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, _toDisplayString(_ctx.translate("country")), 1),
              _createVNode(_component_Field, {
                disabled: !_ctx.isEditionEnabled,
                modelValue: _ctx.form.country,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.country = $event)),
                name: "country",
                class: "form-select form-select-solid",
                "data-control": "select2",
                "data-hide-search": "true",
                "data-placeholder": "Month",
                as: "select",
                id: "country"
              }, {
                default: _withCtx(() => [
                  _hoisted_30,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (country, countryIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      key: countryIndex,
                      value: country.name
                    }, _toDisplayString(country.name), 9, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"]),
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _createVNode(_component_ErrorMessage, { name: "country" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              _createVNode("label", _hoisted_37, [
                _createVNode("span", _hoisted_38, _toDisplayString(_ctx.translate("organizationsType.name")), 1),
                _hoisted_39
              ]),
              _createVNode(_component_Field, {
                disabled: !_ctx.isEditionEnabled,
                modelValue: _ctx.form.organizationsType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.organizationsType = $event)),
                id: "organizations_Type",
                name: "organizationsType",
                class: "form-select form-select-solid",
                "data-control": "select2",
                "data-hide-search": "true",
                "data-placeholder": "Month",
                as: "select"
              }, {
                default: _withCtx(() => [
                  _hoisted_40,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.organizationsType, (orgT) => {
                    return (_openBlock(), _createBlock("option", {
                      key: orgT,
                      value: orgT
                    }, _toDisplayString(_ctx.translate(`organizationsType.${orgT}`)), 9, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode(_component_ErrorMessage, { name: "organizationsType" })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_43, [
        _createVNode("label", _hoisted_44, _toDisplayString(_ctx.translate("organizationReason")), 1),
        _withDirectives(_createVNode("textarea", {
          id: "motivo",
          disabled: !_ctx.isEditionEnabled,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.motive = $event)),
          class: "form-control form-control-solid",
          placeholder: "",
          name: "motive"
        }, null, 8, ["disabled"]), [
          [_vModelText, _ctx.form.motive]
        ])
      ]),
      (_ctx.isCancelButtonVisible && _ctx.isEditionEnabled)
        ? (_openBlock(), _createBlock("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode("label", _hoisted_48, _toDisplayString(_ctx.translate("organizationShareStatistic")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_49, [
        (_ctx.isCancelButtonVisible && _ctx.isEditionEnabled)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              ref: "cancelButtonRef",
              id: "cancel_button",
              type: "reset",
              class: "btn btn-light me-3",
              onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stopEdition && _ctx.stopEdition(...args)), ["prevent"]))
            }, [
              _createVNode("span", _hoisted_50, _toDisplayString(_ctx.translate("cancel")), 1)
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.isEditionEnabled)
          ? (_openBlock(), _createBlock("button", _hoisted_51, [
              _createVNode("span", _hoisted_52, _toDisplayString(_ctx.translate("save")), 1),
              _createVNode("span", _hoisted_53, [
                _createTextVNode(_toDisplayString(_ctx.translate("pleaseWait")) + " ", 1),
                _hoisted_54
              ])
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}